<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="header-container">
            <mat-card-title>Reglas de aprobación</mat-card-title>
            <button [disabled]="!allowedActions.canRegister" mat-raised-button color="primary" (click)="openRegisterMinuteApprovalRuleModal()">
                <mat-icon>add</mat-icon> Nueva
            </button>
        </div>
        <div class="main-container">
            @if(allowedActions.canViewAllApprovalRules){
                <div *ngIf="(minuteApprovalRules$ | async) as minuteApprovalRules; else spinnerloading">
                    <app-minute-request-approval-rule-table 
                    (minuteApprovalRuleIdToView)="receiveMinuteRequestRuleApprovalToView($event)"
                    (minuteApprovalRuleToEnableOrDisable)="receiveMinuteApprovalRuleToEnableOrDisable($event)"
                    (minuteApprovalRuleToUpdate)="receiveMinuteApprovalRuleToUpdate($event)"
                    [canEnableDisableRule]="allowedActions.canEnableDisable"
                    [canUpdateRule]="allowedActions.canUpdate"
                    [minuteApprovalRules]="minuteApprovalRules">
    
                        <app-minute-request-approval-rule-detail *ngIf="minuteRequestApprovalRuleDetail; else loadingDetail"
                        [minuteRequestApprovalRuleDetail]="minuteRequestApprovalRuleDetail"
                        [canUpdateApprovalRule]="allowedActions.canUpdate"
                        (updateMinuteRequestCondition)="receiveUpdateMinuteApprovalCondition($event)"
                        (removeMinuteRequestCondition)="receiceRemoveMinuteApprovalRuleCondition($event)"
                        (registerNewConditions)="receiveEventRegisterMinuteRequestApprovalConditions($event)">
                        </app-minute-request-approval-rule-detail>
                        
                    </app-minute-request-approval-rule-table>
                </div>
            } @else {
                <section class="warn-message">
                    <i-tabler name="alert-triangle"></i-tabler>
                    <span>No tienes permiso para visualizar las reglas de aprobación</span>
                </section>
            }
        </div>
    </mat-card-content>
</mat-card>

<ng-template #spinnerloading>
    <section style="display:flex; justify-content: center;">
        <mat-spinner diameter="70"></mat-spinner>
    </section>
</ng-template>

<ng-template #loadingDetail>
    <section style="display:flex; justify-content: center;">
        <mat-spinner diameter="50"></mat-spinner>
    </section>
</ng-template>